import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { CoreUtils } from '@nhl/nhl-breakaway-ui';

import { parseValueFromLocalizedAttribute } from '~/core/utils';

import { LandingGame, Scoring, ShootoutAttempt as ShootoutAttemptType } from '../../../../types';
import GoalScorer from '../goalScorer/GoalScorer';
import ShootoutAttempt from '../goalScorer/ShootoutAttempt';

import { GoalsContainer, PeriodHeaderContainer } from './styles';

type Props = {
    game: LandingGame;
    scoring?: Scoring;
    shootoutAttempts?: Array<ShootoutAttemptType>;
    isLarge: boolean;
    isWebView: boolean;
};

const GoalsByPeriod: FC<Props> = ({ game, scoring, shootoutAttempts, isLarge, isWebView }) => {
    const intl = useIntl();

    return (
        <>
            <PeriodHeaderContainer role="heading" aria-level={3}>
                {scoring?.periodDescriptor &&
                    CoreUtils.getPeriodDisplayFromDescriptor(intl, scoring.periodDescriptor, game.gameType, true)}
            </PeriodHeaderContainer>
            <GoalsContainer>
                {scoring &&
                    !shootoutAttempts &&
                    scoring.goals.map((goal, index) => {
                        const teamAbbrev = parseValueFromLocalizedAttribute(goal.teamAbbrev);
                        const logoUrl = game.awayTeam.abbrev === teamAbbrev ? game.awayTeam.logo : game.homeTeam.logo;

                        return (
                            <GoalScorer
                                key={index}
                                gameId={game.id}
                                gameState={game.gameState}
                                homeTeam={game.homeTeam}
                                awayTeam={game.awayTeam}
                                goal={goal}
                                logoUrl={logoUrl}
                                isLarge={isLarge}
                                isWebview={isWebView}
                                isLimitedScoring={game.limitedScoring}
                                period={scoring.periodDescriptor.number}
                                eventId={goal.eventId}
                                gameType={game.gameType}
                            />
                        );
                    })}
                {shootoutAttempts &&
                    shootoutAttempts.map((attempt, index) => {
                        const logoUrl =
                            game.awayTeam.abbrev === attempt.teamAbbrev.default
                                ? game.awayTeam.logo
                                : game.homeTeam.logo;

                        return (
                            <ShootoutAttempt
                                key={index}
                                gameState={game.gameState}
                                homeTeam={game.homeTeam}
                                awayTeam={game.awayTeam}
                                shootoutAttempt={attempt}
                                logoUrl={logoUrl}
                                isLarge={isLarge}
                                isWebview={isWebView}
                            />
                        );
                    })}
            </GoalsContainer>
        </>
    );
};

export default GoalsByPeriod;
